import './SingleValue.css';
export var container = '_1sfgzlg0-3-8-0';